import { FC } from 'react';
import { InputToggle } from '../InputToggle/InputToggle';

interface ToggleInputProps {
	htmlFor: string;
	label: string;
	name: string;
	isPunchup?: boolean;
}

export const ToggleInput: FC<ToggleInputProps> = ({ htmlFor, label, name, isPunchup = false }) => {
	return <InputToggle htmlFor={htmlFor} label={label} name={name} isPunchup={isPunchup} />;
};
